import { render, staticRenderFns } from "./q-ans-list.html?vue&type=template&id=25583925&scoped=true&external"
import script from "./q-ans-list.js?vue&type=script&lang=js&external"
export * from "./q-ans-list.js?vue&type=script&lang=js&external"
import style0 from "./q-ans-list.scss?vue&type=style&index=0&id=25583925&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25583925",
  null
  
)

export default component.exports